<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="团队维修记录" name="团队维修记录" class="tab-text">
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="queryParams.column">
                    <el-option
                      v-for="(item,index) in contractScreenCondition"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="params.expression">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                      v-for="(item,index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            border
            ref="tableRef"
            :data="list"
            height="600"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column label="合同编号">
              <template slot-scope="scope">
                <span class="approval">{{scope.row.code}}</span>
              </template>
            </el-table-column>
            <el-table-column label="维修编号">
              <template slot-scope="scope">
                <span class="approval">{{scope.row.code}}</span>
              </template>
            </el-table-column>
            <el-table-column prop label="客户名称" width="100px">
              <template slot-scope="scope">
                <span class="approval">{{scope.row.code}}</span>
              </template>
            </el-table-column>
            <el-table-column prop label="售后类型"></el-table-column>
            <el-table-column prop label="维修产品价值" width="110px"></el-table-column>
            <el-table-column prop label="维修方案"></el-table-column>
            <el-table-column prop label="维修费用"></el-table-column>
            <el-table-column prop label="维修状态"></el-table-column>
            <el-table-column prop label="申请人" width="100px"></el-table-column>
            <el-table-column prop label="所属部门"></el-table-column>
            <el-table-column prop label="申请时间" width="100px"></el-table-column>
            <el-table-column prop label="处理人"></el-table-column>
            <el-table-column prop label="所属部门"></el-table-column>
            <el-table-column prop label="处理时间"></el-table-column>
          </el-table>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      activeName: '团队维修记录',
      expressionList: expressionList,
      queryParams: {}, // 搜索条件
      params: {},
      list: [{ code: 'jw999-000' }],
      loadingTable: false,
      contractScreenCondition: [],
      total: 0,
      currentPage: 1,
      pageSize: 30
    }
  },
  methods: {
    handleClick () {},
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>
